const Full = () => import(/* webpackPrefetch: false */ '@/container/Full.vue')

// dashboard components
const DashboardRoutes = () => import(/* webpackPrefetch: false */ '../views/dashboard/index.vue')
const VoucherBasedBillingRoutes = () => import(/* webpackPrefetch: false */ '@/views/billing/VoucherBasedBilling.vue')
const viewAllUsersElasticRoutes = () => import(/* webpackPrefetch: false */ '../views/users/ViewAllUsersElastic.vue')
const viewAllUsersRoutes = () => import(/* webpackPrefetch: false */ '../views/users/ViewAllUsers.vue')
const createSubzoneRoutes = () => import(/* webpackPrefetch: false */ '../views/dashboard/CreateSubzone.vue')
const applicationDetailsRoutes = () => import('../views/application/index.vue')
export default {
    path: '/dashboard',
    component: Full,
    redirect: '/dashboard',
    beforeEnter(to, from, next) {
        if (localStorage.getItem('token')) {
            next()
        } else {
            next('/signin')
        }
    },
    children: [
        {
            path: '/dashboard',
            component: DashboardRoutes,
            meta: {
                title: "Dashboard"
            }
        },
        {
            path: '/billing/voucher_based_billing/:account/:date',
            component: VoucherBasedBillingRoutes,
            meta: {
                title: "Voucher Based Billing"
            }
        },
        {
            path: '/users/allusers/:account/:status',
            component: viewAllUsersElasticRoutes,
            meta: {
                title: "Users"
            }
        },
        {
            path: '/vouchers/allusers/:account/:status',
            component: viewAllUsersElasticRoutes,
            meta: {
                title: "Users"
            }
        },
        {
            path: '/users/allusers',
            component: viewAllUsersElasticRoutes,
            meta: {
                title: "Users"
            }
        },
        {
            path: '/users/allusers/:account/:status/:from/:to',
            component: viewAllUsersElasticRoutes,
            meta: {
                title: "Users"
            }
        },
        {
            path: '/users/all',
            component: viewAllUsersRoutes,
            meta: {
                title: "Users"
            }
        },
        {
            path: '/users/all/:account/:status',
            component: viewAllUsersRoutes,
            meta: {
                title: "Users"
            }
        },
        {
            path: '/users/all/:account/:status/:from/:to',
            component: viewAllUsersRoutes,
            meta: {
                title: "Users"
            }
        },
        {
            path: '/dashboard/create_subaccount',
            component: createSubzoneRoutes,
            meta: {
                title: "Create Sub Zone"
            }
        },
        {
            path: '/dashboard/create_subaccount/:accountId',
            component: createSubzoneRoutes,
            meta: {
                title: "Create Sub Zone"
            }
        },
        {
            path: '/app_creation/app_details',
            component: applicationDetailsRoutes,
            meta: {
                title: "Application Details"
            }
        },
    ]
}